import { motion } from 'framer-motion';

export function ExpertSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-block bg-teal/10 text-teal px-6 py-2 rounded-full text-sm font-semibold mb-6">
              VOTRE EXPERT LOCAL
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Un Expert de Confiance
              <span className="block text-teal mt-2">à Votre Service</span>
            </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Avec plus de 15 ans d'expérience dans la réparation de fenêtres, baies vitrées et volets roulants à Bordeaux, 
              notre équipe d'artisans certifiés vous garantit un service professionnel et des résultats durables.
            </p>

            {/* Key Points */}
            <div className="space-y-5 mb-10">
              {[
                {
                  icon: 'ri-shield-check-line',
                  title: 'Expertise Certifiée',
                  description: 'Artisans qualifiés RGE avec 15+ ans d\'expérience'
                },
                {
                  icon: 'ri-time-line',
                  title: 'Intervention Rapide',
                  description: 'Dépannage sous 24h partout à Bordeaux et Gironde'
                },
                {
                  icon: 'ri-medal-line',
                  title: 'Garantie Qualité',
                  description: 'Garantie 2 ans sur toutes nos réparations'
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: 'Service Client',
                  description: 'Disponible 7j/7 pour vos urgences'
                }
              ].map((point, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex items-start gap-4"
                >
                  <div className="w-12 h-12 bg-teal/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className={`${point.icon} text-teal text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{point.title}</h3>
                    <p className="text-gray-600">{point.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <motion.button
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                onClick={scrollToContact}
                className="px-8 py-4 bg-orange hover:bg-orange-dark text-white font-bold rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-xl flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <span>Demander un Devis</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </motion.button>

              <motion.a
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.5 }}
                href="tel:+33556123456"
                className="px-8 py-4 bg-white hover:bg-gray-50 text-gray-900 font-bold rounded-xl border-2 border-gray-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl text-teal"></i>
                <span>05 56 12 34 56</span>
              </motion.a>
            </div>
          </motion.div>

          {/* Right Column - Expert Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl w-full h-[600px]">
              <img
                src="https://public.readdy.ai/ai/img_res/e4d7be4bf932f128ad96e4dd5ff51c1d.jpg"
                alt="Expert en réparation de fenêtres à Bordeaux"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-teal/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-orange/20 rounded-full blur-3xl"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
